import React from 'react'

import Box from '@mui/material/Box'
import DashboardDrawer from "./Drawer"
import SearchBar from "./SearchBar";


const drawerWidth = 450

function VideoDisplay(props) {

    const {children} = props

    return (
        <Box sx={{display: "flex"}}>
            <Box
                component={'nav'}
                sx={{width: {xs: 0, md: drawerWidth}, flexShrink: {sm: 0}}}
            >
                <DashboardDrawer drawerWidth={drawerWidth}/>
            </Box>
            <Box component='main'
                 sx={{
                     bgcolor: 'background.paper',
                     flexGrow: 1,
                     p: {xs: 0, md: 0}, width: {xs: '100%', md: `calc(100% - ${drawerWidth}px)`}
                 }}
            >
                <Box><SearchBar/></Box>
                {children}
            </Box>
        </Box>
    )
}

export default VideoDisplay